module.exports = __webpack_public_path__ + "static/img/dh.0797fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh.png
// module id = dIFN
// module chunks = 1